export default __webpack_public_path__ + "static/media/9410_bp.583dd1f9.svg";